// «Cada» + «Unidad», la fila que comparten los drawers Editar y Nueva
// mantención (handoff §6). Controlado por el padre: `every` se guarda como
// texto para que el campo acepte el borrado mientras se escribe; la
// validación (isValidEvery) y la conversión a cadenceDays
// (composeCadence) ocurren al guardar.

import { useId } from "react";
import { CADENCE_FORM_UNITS, CADENCE_UNIT_LABELS, type CadenceUnit } from "./cadence";

export type CadenceFieldsProps = {
  every: string;
  unit: CadenceUnit;
  onEveryChange: (value: string) => void;
  onUnitChange: (unit: CadenceUnit) => void;
  disabled?: boolean;
};

export function CadenceFields({
  every,
  unit,
  onEveryChange,
  onUnitChange,
  disabled = false,
}: CadenceFieldsProps) {
  const everyId = useId();
  const unitId = useId();
  // «Días» sólo se ofrece si la cadencia guardada ya está en días (no es
  // múltiplo de semanas, meses ni años); si no, las tres del handoff.
  const units: readonly CadenceUnit[] =
    unit === "days" ? [...CADENCE_FORM_UNITS, "days"] : CADENCE_FORM_UNITS;
  return (
    <div className="grid-2">
      <div className="field ag-field">
        <label className="field__label" htmlFor={everyId}>
          Cada
        </label>
        <input
          id={everyId}
          className="input mono"
          type="number"
          inputMode="numeric"
          min={1}
          step={1}
          value={every}
          onChange={(e) => onEveryChange(e.target.value)}
          disabled={disabled}
        />
      </div>
      <div className="field ag-field">
        <label className="field__label" htmlFor={unitId}>
          Unidad
        </label>
        <select
          id={unitId}
          className="select"
          value={unit}
          onChange={(e) => onUnitChange(e.target.value as CadenceUnit)}
          disabled={disabled}
        >
          {units.map((u) => (
            <option key={u} value={u}>
              {CADENCE_UNIT_LABELS[u]}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
